import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BannerRotativeService } from 'src/app/services/banner-rotative.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-banner-rotative',
  templateUrl: './banner-rotative.component.html',
  styleUrls: ['./banner-rotative.component.scss'],
  host: { class: 'wrapper-settings' },
})
export class BannerRotativeComponent implements OnInit {
  public banners: any[];

  public loadingBanner: boolean = false;

  public allSelected: boolean = false;
  public canDelete: boolean = false;

  constructor(private _bannerRotativeService: BannerRotativeService) {}

  ngOnInit(): void {
    this.banners = [];
    this.find();
  }

  onSelectAll(): void {
    this.canDelete = false;
    if (this.allSelected) {
      this.canDelete = true;
    }
    for (let i in this.banners) {
      this.banners[i]['selected'] = this.allSelected;
    }
  }

  onSelect(): void {
    let hasOne = false;
    this.allSelected = true;
    for (let i in this.banners) {
      if (this.banners[i]['selected']) {
        this.canDelete = true;
        hasOne = true;
      } else {
        this.allSelected = false;
      }
    }
    if (!hasOne) this.canDelete = false;
  }

  find() {
    this.loadingBanner = true;

    this._bannerRotativeService.list().subscribe((res) => {
      if (res.success) {
        for (let i in res.banners) {
          res.banners[i]['selected'] = false;
        }
        this.banners = res.banners;
      }
      this.loadingBanner = false;
    });
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.banners, event.previousIndex, event.currentIndex);

    let ordem = [];
    let n = 1;
    for (let i in this.banners) {
      ordem.push({
        idbanner: this.banners[i].idbanner,
        ordem: n,
      });
      this.banners[i].posicao = n;
      ++n;
    }
    this._bannerRotativeService.patchOrdem({ ordem }).subscribe((res) => {});
  }

  getDayWeek(number) {
    switch (number) {
      case 2:
        return 'Mostra em todas as Segundas-feiras';
      case 3:
        return 'Mostra em todas as Terças-feiras';
      case 4:
        return 'Mostra em todas as Quartas-feiras';
      case 5:
        return 'Mostra em todas as Quintas-feiras';
      case 6:
        return 'Mostra em todas as Sextas-feiras';
      case 7:
        return 'Mostra em todas os Sábados';
      case 1:
        return 'Mostra em todas os Domingos';
    }
  }

  deleteError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar apagar!', 'error');
  }

  deleteComplete() {
    let title = 'O banner foi apagado!';
    let arr = [];
    for (let i in this.banners) {
      if (this.banners[i]['selected']) {
        arr.push(this.banners[i]['idbanner']);
      }
    }
    if (arr.length > 1) {
      title = 'Os banners foram apagados!';
    }

    Swal.fire('Salvo!', title, 'success');

    this.canDelete = false;
    this.find();
  }

  deleting() {
    Swal.fire({
      title: 'Apagando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  onDeleteBanner() {
    let title = 'Você deseja apagar o banner selecionado? ';
    let arr = [];
    let arrDescriptions = [];
    for (let i in this.banners) {
      if (this.banners[i]['selected']) {
        arr.push(this.banners[i]['idbanner']);
        arrDescriptions.push(this.banners[i]['titulo']);
      }
    }
    if (arr.length > 1) {
      title = 'Você deseja apagar os banners selecionados? ';
    }
    Swal.fire({
      title: title + arrDescriptions.join(', '),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
    }).then((result) => {
      if (result.value) {
        let ids = arr.join(',');
        if (ids != '') {
          this.deleting();

          this._bannerRotativeService.delete(ids).subscribe((res) => {
            if (res.success) {
              this.deleteComplete();
            } else {
              this.deleteError();
            }
          });
        }
      }
    });
  }
}
